export default __webpack_public_path__ + "900d1736a5fc58d5801c3975c017b288.png";